/**
 * Seeker CV (profile) endpoints. `save` performs a full upsert of the CV —
 * personal block, summary, preferences and the repeatable section arrays —
 * matching the backend's whole-document sync.
 */
export function useProfile() {
  const { apiFetch } = useApi()

  async function get<T = any>(): Promise<T> {
    const res = await apiFetch<{ data: T }>('/profile')
    return res.data
  }

  async function getById<T = any>(profileId: number): Promise<T> {
    const res = await apiFetch<{ data: T }>(`/profiles/${profileId}`)
    return res.data
  }

  async function save<T = any>(payload: Record<string, unknown>): Promise<T> {
    const res = await apiFetch<{ data: T }>('/profile', {
      method: 'PUT',
      body: payload,
    })
    return res.data
  }

  async function uploadPhoto<T = any>(file: File): Promise<T> {
    const form = new FormData()
    form.append('photo', file)
    const res = await apiFetch<{ data: T }>('/profile/photo', {
      method: 'POST',
      body: form,
    })
    return res.data
  }

  async function removePhoto<T = any>(): Promise<T> {
    const res = await apiFetch<{ data: T }>('/profile/photo', { method: 'DELETE' })
    return res.data
  }

  return { get, getById, save, uploadPhoto, removePhoto }
}
